import axios, { AxiosInstance } from "axios";
const SKY_LOGIN_BFF_URL = "https://sky-login-bff.skyairline.com";

class LoginBffClient {
  private url: string;
  public client: AxiosInstance;

  constructor(url: string) {
    this.url = url;
    this.createClient();
  }

  public createClient() {
    const client = axios.create({
      baseURL: this.url,
    });

    client.defaults.headers["Content-Type"] = "application/json; charset=utf-8";
    client.defaults.headers.Accept = "application/json; charset=utf-8";

    this.client = client;
  }

  public recoverPassword(email: string): Promise<any> {
    return this.client.post("/recover-password", { email });
  }
}

export const recoverPassword = async (email: string) => {
  try {
    const loginBffClient = new LoginBffClient(SKY_LOGIN_BFF_URL);
    const response = await loginBffClient.recoverPassword(email);
    return response;
  } catch (error) {
    return { error };
  }
};
